import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/logo.png";
import RegisterForm from "../components/organisms/RegisterForm";

const Register = () => {
  const navigate = useNavigate();

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-10 sm:px-6">
      <section className="w-full max-w-md rounded-lg border border-slate-200 bg-white px-6 py-8 shadow-sm sm:px-8 sm:py-10">
        <div className="mb-8 text-center">
          <a className="mb-6 inline-flex justify-center" href="/">
            <img
              alt="Civix"
              loading="lazy"
              width="61"
              height="38"
              decoding="async"
              src={Logo}
            />
          </a>
          <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-slate-500">
            Create account
          </p>
          <h1 className="text-3xl font-bold leading-tight text-slate-950">
            Get started with Civix
          </h1>
          <p className="mt-3 leading-7 text-slate-600">
            Create your account and start managing your workspace.
          </p>
        </div>

        <RegisterForm />

        <p className="mt-8 text-center text-sm leading-6 text-slate-500">
          Already have an account?
          <button
            className="ml-2 cursor-pointer border-none bg-transparent p-0 font-semibold text-slate-900 transition-colors hover:text-blue-600"
            onClick={() => navigate("/login")}
            type="button"
          >
            Sign in
          </button>
        </p>
      </section>
    </main>
  );
};

export default Register;
